import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, OnDestroy} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {StorageService} from './storage.service';
import {environment} from '~environments/environment';
import {AuthenticatedUser, User} from '../models';

/**
 * CRUD service for the user entity.
 */
@UntilDestroy()
@Injectable()
export class UserService implements OnDestroy {
  public API_URL: any = `${environment.envAPI}`;
  public authenticatedUser: AuthenticatedUser;

  constructor(private http: HttpClient, private storage: StorageService) {
    this.storage.authenticatedUser
      .pipe(untilDestroyed(this))
      .subscribe((user: AuthenticatedUser) => this.authenticatedUser = user);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Get users.
   */
  public getAll(page: number = 1, limit: number = 10, options: any): Observable<Array<User>> {
    const pageStr = String(page);
    const limitStr = String(limit);

    let url = '';
    if (this.authenticatedUser.isAdmin) {
      if (options.clubSelected !== 'allClubs') {
        url = `${this.API_URL}/clubs/${options.clubSelected}/users`;
      } else {
        url = `${this.API_URL}/users`;
      }
    } else {
      url = `${this.API_URL}/clubs/${this.authenticatedUser.clubs[0].id}/users`;
    }

    const params: HttpParams = new HttpParams({
      fromObject: {
        'page': pageStr,
        'itemsPerPage': limitStr,
        'order[enabled]': 'desc',
        'orSearchAll': options.userSearched.trim()
      }
    });

    return this.http.get<Array<User>>(url, {params});
  }

  public getClubUsersEndpoint(id): any {
    const api = `${this.API_URL}/clubs/${id}/users`;

    const params: Array<any> = [
      {'order[enabled]': 'desc'},
      {'type[]': 'ClubAdmin'},
      {'type[]': 'TicketAgent'},
    ];

    return [api, params];
  }

  public getGlobalUsersEndpoint(options): any {
    let api;
    if (options.clubSelected !== 'allClubs') {
      api = `${this.API_URL}/clubs/${options.clubSelected}/users`;
    } else {
      api = `${this.API_URL}/users`;
    }

    const params: Array<any> = [
      {'order[enabled]': 'desc'},
    ];

    return [api, params];
  }

  /**
   * Get user by id.
   */
  public getById(id: number): Observable<User> {
    return this.http.get<User>(`${this.API_URL}/users/${id}`);
  }

  /**
   * Create a new user.
   */
  public create(user: User): Observable<User> {
    return this.http.post<User>(`${this.API_URL}/users`, user);
  }

  /**
   * Update a user.
   */
  public update(user: any, id: number): Observable<User> {
    return this.http.patch<User>(`${this.API_URL}/users/${id}`, user);
  }
}
